import { styled } from '@mui/material';
import { Typography, Image } from 'core/common/ui/ui-kit';
import { InfoList } from './InfoList';

const paddingMobile = '12';
const paddingDesktop = '32';

export const WrapperStyled = styled('div')`
  display: flex;
  flex-wrap: wrap;
  padding-top: 60px;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    padding-top: 0;
    border-radius: 20px;
    background-color: ${({ theme }) => theme.palette.contentBlockBackground.main};
  }
`;

export const ImageWrapperStyled = styled('div')`
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: ${paddingMobile}px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    padding: ${paddingDesktop}px;
    background-color: ${({ theme }) => theme.palette.contentBlockBackground.main};
  }
`;

export const ImageStyled = styled(Image)`
  width: 110px;
`;

export const LabelSectionWrapperStyled = styled('div')`
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.main};

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};
  }

  &::before {
    position: absolute;
    top: 12px;
    left: 50%;
    width: 1px;
    height: calc(100% - ${paddingMobile}px * 2);
    background-color: ${({ theme }) => theme.palette.background.accent};
    transform: translateX(-50%);
    content: '';

    ${({ theme }) => theme.breakpoints.up('mobile')} {
      height: calc(100% - ${paddingDesktop}px * 2);
    }
  }
`;

export const LabelSectionItemStyled = styled(Typography)`
  width: 50%;
  text-align: center;
`;

export const InfoListWrapperStyled = styled('div')`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;

  &::before {
    position: absolute;
    top: 0;
    left: 50%;
    width: 1px;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.background.accent};
    transform: translateX(-50%);
    content: '';
  }
`;

export const InfoListStyled = styled(InfoList)`
  position: relative;
  flex-direction: column;
  align-items: center;
  width: 100%;

  li {
    width: calc(100% - ${paddingMobile}px * 2);
    border-bottom: 1px solid ${({ theme }) => theme.palette.background.accent};

    ${({ theme }) => theme.breakpoints.up('mobile')} {
      width: calc(100% - ${paddingDesktop}px * 2);
      margin-bottom: 32px;
    }
  }

  li:nth-last-of-type(-n + 1) {
    border-bottom: none;
  }
`;

export const SingleInfoListStyled = styled(InfoList)`
  position: relative;
  justify-content: space-around;

  &::before {
    position: absolute;
    top: 0;
    left: 50%;
    width: 1px;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.background.accent};
    transform: translateX(-50%);
    content: '';
  }

  li {
    width: calc(50% - ${paddingMobile}px * 2);
    border-bottom: 1px solid ${({ theme }) => theme.palette.background.accent};

    ${({ theme }) => theme.breakpoints.up('mobile')} {
      width: calc(50% - ${paddingDesktop}px * 2);
    }
  }

  li:nth-last-of-type(-n + 2) {
    border-bottom: none;
  }
`;
